import { Component, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ResourcesService } from '../services/resources.service';
import { AdminResource } from '../models/resource-model';
import { UserRolesService } from '../services/user-roles.service';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ResourceModule } from '../constants/constants'; 
@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
 

export class ResourcesComponent implements OnInit {
    constructor(private resourceService: ResourcesService, private _sanitizer: DomSanitizer, public userRoleService: UserRolesService, private render: Renderer2, private confirmationDialogService: ConfirmationDialogService) {

    }

    resourceEditDropdown: boolean = false;
    editPopUp: boolean = false;
    linkText: string = "";
    totalResources: number = 0;
    popupTitle: string = "";
    adminResource: AdminResource;
    resourcesData: any;
    sortOrder: any;
    showOrderingSave: boolean = false;
    adminResourceID: any;
    selectedData: any;
    viewModeOn: boolean = false;
    description: any;
    editorData: any;
    titleData: string = "";
    validateTitle: boolean = false;
    editorDisable: boolean = false;
    hoverIndex: number = -1;
    dragIndex: number = -1;
    config: any;
    showEdit: boolean = false;
    showRemove: boolean = false;
    showReorder: boolean = false;
    showAddResources: boolean = false;
    isViewMode: boolean = false;
    showResourceCount: boolean = false;
    showLoader:boolean = false;
    totalCount: number = 0;
    resourceModule = ResourceModule;
    ngOnInit() {
        this.showLoader = true;
        this.loadData();
        this.linkText = "<a href='https://businesschemistry.deloitte.com' target='_blank'> Business chemistry </a>";
        this.config = { toolbar: [['Bold', 'Italic']], removePlugins: 'elementspath' }

        this.render.listen('body', 'mousedown', (event) => {
            const anchor = document.getElementsByClassName('resourceDescription');
            if (event !== undefined && anchor.length > 0) {
                var targetobj = event.target;
                if (targetobj.localName === "strong" || targetobj.localName === "em") {
                    targetobj = event?.path[1];
                }
                if (targetobj instanceof HTMLAnchorElement === false) {
                    return;
              } //if not an anchor tag..do nothing!
              const target = <HTMLAnchorElement>targetobj;
                if (target.href !== "") {
                    event.preventDefault();
                    window.open(target.href, "_blank"); //open specified anchor in new tab
                }
            }
        });


        this.userRoleService.roleIdSubject.subscribe(data => {

            if (data === 2 || data === 3 || data === 4 || data === 5 || data === 6 || data === 8) {
                this.showEdit = false;
                this.showRemove = false;
                this.showReorder = false;
                this.showAddResources = false;
            } else {
                this.showEdit = true;
                this.showRemove = true;
                this.showReorder = true;
                this.showAddResources = true;

            }
        });


    }

    onDrop(event: CdkDragDrop<any[]>) {
        if (event.previousIndex === event.currentIndex) {
            return;
        }
        this.onAnyDrop(this.resourcesData[event.previousIndex], event.currentIndex);
    }


    SaveData(data: string) {
        this.editorData = data;
    }
    dragclick(i) {

        this.dragIndex = i;
    }
    loadData() {
        this.resourceService.getResourcesData(true).subscribe(res => {
            this.resourcesData = res;
            this.showResourceCount = true;
            this.showLoader = false;
            this.totalResources = res[0].TotalCount;
        },
    (err)=> { this.showLoader = false; })
        this.hoverIndex = -1;
    }
    resourceEditDrop(i) {
        //Bug 3943420 fix
        if (this.hoverIndex === i) {
            this.resetHoverIndex();
        }
        else {
            this.resourceEditDropdown = !this.resourceEditDropdown;
            this.hoverIndex = i;
        }
    }
    //Bug 3943420 fix
    resetHoverIndex() {
        this.hoverIndex = -1;
    }

    addResourcePop() {
        this.sortOrder = 0;
        this.isViewMode = false;
        this.adminResourceID = 0;
        this.hoverIndex = -1;
        this.editPopUp = true;
        this.editorDisable = false;
        this.editorData = "";
        this.titleData = "";
        this.viewModeOn = false;
        this.popupTitle = "Add Resource";
        this.gotoTop();
        document.body.style.position = 'fixed';
    }
    editResourcePop(index) {
        window.scroll(0, 0);
        this.isViewMode = false;
        this.hoverIndex = -1;
        this.editPopUp = true;
        this.sortOrder = this.resourcesData[index].SortOrder;
        this.adminResourceID = this.resourcesData[index].AdminResourceID;
        this.editorData = this.resourcesData[index].Description;
        this.titleData = this.resourcesData[index].Title;
        this.editorDisable = false;
        this.viewModeOn = false;
        this.popupTitle = "Edit Resource";
        this.gotoTop();
        document.body.style.position = 'fixed';
    }
    viewResourcePop(index) {
        window.scroll(0, 0);
        this.isViewMode = true;
        this.hoverIndex = -1;
        this.editPopUp = true;
        this.editorData = this.resourcesData[index].Description;
        this.titleData = this.resourcesData[index].Title;
        this.editorDisable = true;
        this.viewModeOn = true;
        this.popupTitle = "View Resource";
        this.gotoTop();
        document.body.style.position = 'fixed';
    }
    removeResourcePop(index) {
        this.hoverIndex = -1;
        this.confirmationDialogService
            .confirm(
                "Confirmation",
                "Do you wish to delete this resource?",
                "YES",
                "NO",
                null,
                false,
                true
            )
            .then((confirmed) => {
                if (confirmed) {
                    this.adminResource = this.resourcesData[index];
                  this.resourceService.addEditRemoveData(this.adminResource, true).subscribe(x => { 

                        this.loadData();
                    });
                }
            });
    }
    coloseEditResourcePop() {
        this.editPopUp = false;
        this.validateTitle = false;
        document.body.style.position = 'initial';
    }
    saveEditor() {
        document.body.style.position = 'initial';
        if (this.titleData.trim() === "" || this.editorData.trim() === "") {
            this.validateTitle = true;
        }
        else {
          this.validateTitle = false;
          this.showLoader = true;
            this.adminResource = {
                TotalCount: this.totalCount,
                IsActive: true, Description: this.editorData, Title: this.titleData
                , SortOrder: this.sortOrder, AdminResourceID: this.adminResourceID, CreatedBy: "", ModifiedBy: "", PopulateDescription: ""
                , ShortDescription: "", CreatedDate: null, ModifiedDate: null,

            };
            this.resourceService.addEditRemoveData(this.adminResource, false).subscribe(x => {
                this.loadData();
            });
            this.editPopUp = false;
        }



    }

    dragEnabled = false;

    onReorderClick() {
        this.hoverIndex = -1;
        this.dragEnabled = true;
        this.showOrderingSave = true;
    }
    saveOrder() {

        this.resourceService.updateSortOrder(this.resourcesData).subscribe(x => {
            this.loadData();
            this.showOrderingSave = false;
        })
        this.hoverIndex = -1;
        this.dragEnabled = false;

    }
    cancelOrder() {
        this.hoverIndex = -1;
        this.dragEnabled = false;
        this.showOrderingSave = false;
        this.loadData();
    }



    onAnyDrop(e: any, val) {
        let index: number = this.resourcesData.indexOf(e);
        const sortorder = this.resourcesData[val].SortOrder;
        let changedSortOrder = -1;
        let sortOrderChages = -1;
        if (index < val) {
            index = index + 1;
            for (var i = index; i <= val; i++) {

                if (changedSortOrder === -1)
                    changedSortOrder = this.resourcesData[i - 1].SortOrder;
                sortOrderChages = this.resourcesData[i].SortOrder;
                this.resourcesData[i].SortOrder = changedSortOrder;
                changedSortOrder = sortOrderChages;
            }
        }
        else {
            for (var i = index; i >= val; i--) {

                if (changedSortOrder === -1)
                    changedSortOrder = this.resourcesData[val].SortOrder;
                sortOrderChages = this.resourcesData[i].SortOrder;
                this.resourcesData[i].SortOrder = changedSortOrder;
                changedSortOrder = sortOrderChages;
            }
        }


        e.SortOrder = sortorder;

        this.removeItem(e, this.resourcesData);
        this.resourcesData.splice(val, 0, e);
    }

    removeItem(item: any, list: Array<any>) {
      const index = list.map(function (e) {
            return e.AdminResourceID
        }).indexOf(item.AdminResourceID);
        list.splice(index, 1);
    }



  str: any
    htmltag(val) { 
      this.str = val.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "").replace(/&quot;/g, "")
      return this.str; 
  } 


    gotoTop() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }


}
